import React, { useEffect, useState } from 'react';
import DocsApi from 'services/KjederegisteretAdminApi/DocsApi';

interface Props {
  slug: string;
  path: string;
  alt?: string;
}

/** Bilde fra api/docs. Hentes med token og vises som object-URL. */
const AuthImage = ({ slug, path, alt }: Props) => {
  const [url, setUrl] = useState<string | undefined>();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | undefined;
    let cancelled = false;
    setUrl(undefined);
    setFailed(false);
    DocsApi.getImageUrl(slug, path)
      .then((u) => {
        if (cancelled) URL.revokeObjectURL(u);
        else {
          objectUrl = u;
          setUrl(u);
        }
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [slug, path]);

  if (failed) return <em>[Bildet kunne ikke lastes: {alt ?? path}]</em>;
  if (!url) return <span className="text-muted">Laster bilde …</span>;
  return <img src={url} alt={alt ?? ''} />;
};

export default AuthImage;
